import Loc from "../../Loc/Loc";

interface SendingCodeProps {
    type: string;
}

export default function SendingCode(props: SendingCodeProps) {
    return (
        <div className="alert alert-info mt-3" style={{marginLeft: 'auto', marginRight: 'auto', width: '382px'}}>
            <div style={{fontSize: '2rem'}}>{Loc.trad().SendingCodeInProgress}{props.type}{Loc.trad().SendingCodeInProgress2}<span style={{fontSize: '1rem'}} className="spinner-border spinner-border-sm mr-1"></span></div>
        </div>
    )
}